// @ts-nocheck
import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import PlayerOverlay from 'components/pages/playback/PlayerOverlay';
import AreYouStillWatching from 'components/pages/AreYouStillWatching';

import PlayerFunnel from './PlayerFunnel';
import PlayerResource from './PlayerResource';
import Player from './Player';
import DRMProvider from './DRMProvider';

const HeroPlayback = ({
  videoId,
  onVideoCompleted,
  onError,
  id,
  isCarousel,
  fullScreenPlayer,
  slideNum,
}) => {
  const isCcEnabled = useSelector(state => state.closedCaptioning);
  return (
    <React.Fragment>
      <PlayerFunnel
        videoId={videoId}
        onError={onError}
        isCarousel
        render={({
          videoToPlay,
          videoToDisplay,
          isGTAutoplay,
          row,
          authorizedProvider,
          loading: authLoading,
          onPlaybackError,
          onSetResource,
        }) => (
          <PlayerResource
            videoToPlay={videoToPlay}
            videoToDisplay={videoToDisplay}
            row={row}
            isAutoplay={isGTAutoplay}
            authorizedProvider={authorizedProvider}
            onError={onError}
            isCarousel={isCarousel}
            slideNum={slideNum}
            render={({ resource, loading: resourceLoading }) => (
              <DRMProvider
                onError={onError}
                resource={resource}
                video={videoToPlay}
                render={({ resource: resourceWithDRM }) => {
                  return (
                    <Player
                      resource={resourceWithDRM}
                      onPlaylistComplete={onVideoCompleted}
                      onError={onPlaybackError}
                      loading={authLoading || resourceLoading}
                      onResourceSet={onSetResource}
                      id={id}
                      isCarousel={isCarousel}
                      fullScreenPlayer={fullScreenPlayer}
                      isCcEnabled={fullScreenPlayer && isCcEnabled}
                    />
                  );
                }}
              />
            )}
          />
        )}
      />
      {fullScreenPlayer && (
        <PlayerOverlay fullScreenPlayer={fullScreenPlayer} />
      )}
      {fullScreenPlayer && <AreYouStillWatching />}
    </React.Fragment>
  );
};

HeroPlayback.propTypes = {
  videoId: PropTypes.string,
  onVideoCompleted: PropTypes.func,
  onError: PropTypes.func,
  isCarousel: PropTypes.bool,
  id: PropTypes.string,
  fullScreenPlayer: PropTypes.bool,
  slideNum: PropTypes.number,
};

HeroPlayback.defaultProps = {
  videoId: null,
  onVideoCompleted: () => null,
  onError: () => null,
  isCarousel: false,
  id: null,
  fullScreenPlayer: PropTypes.bool,
  slideNum: null,
};

export default HeroPlayback;
